import * as Y from 'yjs';

import { type Update } from '../network/abstract-batched-updates';
import { type UpdateMetadata } from '../network/yjs-socket';

export function mergeUpdate(
  updates: Update<Uint8Array<ArrayBuffer>, UpdateMetadata>[]
): Update<Uint8Array<ArrayBuffer>, UpdateMetadata> {
  const rawUpdates = updates.map((update) => update.payload);
  const update = new Uint8Array(Y.mergeUpdates(rawUpdates));

  return {
    payload: update,
    origin: updates[updates.length - 1].origin,
    clientID: updates[updates.length - 1].clientID,
    clock: updates[updates.length - 1].clock,
  };
}
